const Items = {
  APP_STATE: "state:app",
  GTM_STATE: "state:gtm",
};

const initializeState = (item) => {
  switch (item) {
    case Items.GTM_STATE:
      return {
        date: null,
        firstCall: false,
        isLoggedIn: false,
        validationTime: 0 * 60 * 1000,
      };
    case Items.APP_STATE:
    default:
      return {};
  }
};

const loadState = (item) => {
  try {
    const serializedState = localStorage.getItem(item);

    if (serializedState === null) {
      return initializeState(item);
    }

    return JSON.parse(serializedState);
  } catch (err) {
    return initializeState(item);
  }
};

const saveState = (state, item) => {
  try {
    localStorage.setItem(item, JSON.stringify(state));
  } catch (err) {
    console.error(err);
  }
};

const removeState = (item) => {
  try {
    localStorage.removeItem(item);
  } catch (err) {
    console.error(err);
  }
};

export { loadState, saveState, removeState, Items };
